var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduceCapacity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reduce_capacity"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_451_3607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9091 23.182C91.9091 16.882 97.0636 11.7275 103.364 11.7275C109.664 11.7275 114.818 16.882 114.818 23.182C114.818 29.482 109.664 34.6366 103.364 34.6366C97.0636 34.6366 91.9091 29.482 91.9091 23.182ZM119.285 43.6857C114.417 41.5666 109.034 40.3638 103.364 40.3638C99.5263 40.3638 95.8609 40.9366 92.3672 41.9675C95.6891 45.1175 97.6363 49.5275 97.6363 54.2811V57.5457H126.273V54.2811C126.273 49.642 123.524 45.5184 119.285 43.6857ZM34.6363 34.6366C40.9363 34.6366 46.0909 29.482 46.0909 23.182C46.0909 16.882 40.9363 11.7275 34.6363 11.7275C28.3363 11.7275 23.1818 16.882 23.1818 23.182C23.1818 29.482 28.3363 34.6366 34.6363 34.6366ZM45.6327 41.9675C42.1391 40.9366 38.4736 40.3638 34.6363 40.3638C28.9663 40.3638 23.5827 41.5666 18.7145 43.6857C14.4763 45.5184 11.7272 49.642 11.7272 54.2811V57.5457H40.3636V54.2811C40.3636 49.5275 42.3109 45.1175 45.6327 41.9675ZM57.5454 23.182C57.5454 16.882 62.7 11.7275 69 11.7275C75.3 11.7275 80.4545 16.882 80.4545 23.182C80.4545 29.482 75.3 34.6366 69 34.6366C62.7 34.6366 57.5454 29.482 57.5454 23.182ZM91.9091 57.5457H46.0909V54.2811C46.0909 49.642 48.84 45.5184 53.0782 43.6857C57.9463 41.5666 63.33 40.3638 69 40.3638C74.67 40.3638 80.0536 41.5666 84.9218 43.6857C89.16 45.5184 91.9091 49.642 91.9091 54.2811V57.5457ZM86.1818 91.9093C86.1818 85.6093 91.3363 80.4548 97.6363 80.4548C103.936 80.4548 109.091 85.6093 109.091 91.9093C109.091 98.2093 103.936 103.364 97.6363 103.364C91.3363 103.364 86.1818 98.2093 86.1818 91.9093ZM120.545 126.273H74.7272V123.008C74.7272 118.369 77.4763 114.246 81.7145 112.413C86.5827 110.294 91.9663 109.091 97.6363 109.091C103.306 109.091 108.69 110.294 113.558 112.413C117.796 114.246 120.545 118.369 120.545 123.008V126.273ZM28.9091 91.9093C28.9091 85.6093 34.0636 80.4548 40.3636 80.4548C46.6636 80.4548 51.8182 85.6093 51.8182 91.9093C51.8182 98.2093 46.6636 103.364 40.3636 103.364C34.0636 103.364 28.9091 98.2093 28.9091 91.9093ZM63.2727 126.273H17.4545V123.008C17.4545 118.369 20.2036 114.246 24.4418 112.413C29.31 110.294 34.6936 109.091 40.3636 109.091C46.0336 109.091 51.4172 110.294 56.2854 112.413C60.5236 114.246 63.2727 118.369 63.2727 123.008V126.273ZM73.2954 74.7275V63.2729H64.7045V74.7275H51.8182L69 91.9093L86.1818 74.7275H73.2954Z",
    fill: "#447D00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_451_3607",
    x: 8.72725,
    y: 9.72748,
    width: 120.545,
    height: 120.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.294118 0 0 0 0 0.286275 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_451_3607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_451_3607",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceCapacity);
export default __webpack_public_path__ + "static/media/reduce-capacity.efff1a2e3da27acf8815edf8210cc88c.svg";
export { ForwardRef as ReactComponent };